
import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
  type RouterScrollBehavior,
  type RouteLocationNormalized,
  type NavigationGuardNext,
  type RouteRecordNormalized
} from 'vue-router'
import HomePage from '@/components/pages/01000_HomePage.vue'
import SigninPage from '@/components/pages/00000_SigninPage.vue'
import ItemSearchPage from '@/components/pages/01001_ItemSearchPage.vue'
import ItemSearchWithCategoryPage from '@/components/pages/01001_ItemSearchWithCategoryPage.vue'
import InternalServerError from '@/components/pages/99000_InternalServerErrorPage.vue'
import { useAuthFunc } from '@/utils/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/signin',
    name: 'signin',
    component: SigninPage,
    meta: {
      requiresAuth: false,
      title: 'ログインページ',
      description: '',
    },
  },
  {
    path: '/',
    name: 'home',
    meta: {
      requiresAuth: true,
      title: 'トップページ',
      description: '',
    },
    redirect: { name: 'items' },
  },
  {
    path: '/items/category/:largeCategoryCd',
    name: 'large_category',
    meta: {
      requiresAuth: true,
      title: 'トップページ',
      description: '',
    },
    props: true,
    component: ItemSearchWithCategoryPage,
    children: [
      {
        path: ':middleCategoryCd',
        name: 'middle_category',
        meta: {
          requiresAuth: true,
          title: 'トップページ',
          description: '',
        },
        props: true,
        component: ItemSearchWithCategoryPage,
      }
    ]
  },
  {
    path: '/items/detail/:itemCd',
    name: 'item_detail',
    meta: {
      requiresAuth: true,
      title: '商品詳細',
      description: '',
    },
    props: true,
    component: () => import('@/components/pages/01002_ItemDetailPage.vue'),
  },
  {
    path: '/items',
    name: 'items',
    meta: {
      requiresAuth: true,
      title: 'トップページ',
      description: '',
    },
    props: true,
    component: ItemSearchPage,
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('@/components/pages/02000_CartPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'カート',
      description: '',
    },
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    component: () => import('@/components/pages/11000_WishlistPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'お気に入り',
      description: '',
    },
  },
  {
    path: '/order_request',
    name: 'order_request',
    component: () => import('@/components/pages/03000_OrderRequestPage.vue'),
    meta: {
      requiresAuth: true,
      title: '注文依頼情報の入力',
      description: '',
    },
  },
  {
    path: '/mypage',
    name: 'mypage',
    component: () => import('@/components/pages/04000_MyPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'マイページ',
      description: '',
    },
  },
  {
    path: '/mypage/account',
    name: 'account',
    component: () => import('@/components/pages/10000_AccountPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'ご登録情報',
      description: '',
    },
  },
  {
    path: '/mypage/order_requests',
    name: 'order_requests',
    component: () => import('@/components/pages/06000_OrderRequestListPage.vue'),
    meta: {
      requiresAuth: true,
      title: '注文依頼一覧',
      description: '',
    },
  },
  {
    path: '/mypage/order_requests/detail/:orderRequestId',
    name: 'order_request_detail',
    props: true,
    component: () => import('@/components/pages/06001_OrderRequestDetailPage.vue'),
    meta: {
      requiresAuth: true,
      title: '注文依頼詳細',
      description: '',
    },
  },
  {
    path: '/mypage/billing_address',
    name: 'billing_address',
    component: () => import('@/components/pages/08000_BillingAddressListPage.vue'),
    meta: {
      requiresAuth: true,
      title: '請求先一覧',
      description: '',
    },
  },
  {
    path: '/mypage/delivery_address',
    name: 'delivery_address',
    component: () => import('@/components/pages/09000_DeliveryAddressListPage.vue'),
    meta: {
      requiresAuth: true,
      title: '配送先一覧',
      description: '',
    },
  },
  {
    path: '/error',
    name: 'InternalServerError',
    component: () => import('@/components/pages/99000_InternalServerErrorPage.vue'),
  },
  {
    path: '/503',
    name: 'ServiceTemporarilyUnavailable',
    component: () => import('@/components/pages/90000_ServiceTemporarilyUnavailablePage.vue'),
  },
  {
    path:"/:pathMatch(.*)*",
    name: 'NotFound',
    component: () => import('@/components/pages/90000_NotFoundPage.vue'),
    meta: {
      requiresAuth: true,
      title: '404 NotFound',
      description: '',
    },
  },
]

// ページ遷移時は常にTOPにスクロール
const scrollBehavior: RouterScrollBehavior = () => ({ top: 0, left: 0 });

// router
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior,
})

router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  // Auth required ?
  if (!(to.matched.some((record : RouteRecordNormalized) => record.meta.requiresAuth || record.meta.requiresAuth === true))) return next();

  // is loggedin ?
  if (!useAuthFunc().isLoggedin()) {
    return next({
      path: '/signin',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  return next()
})

export default router
